module.exports = __webpack_public_path__ + "static/media/RsvpLogo.3b2aa7b4.svg";